export enum DialogsEnum {
    REGIONAL_RESTRICTIONS = "REGIONAL_RESTRICTIONS",
    AUTH = "AUTH",
    LOG_OUT = "LOG_OUT",
    SET_NEW_PASSWORD = "SET_NEW_PASSWORD",
    BONUS_CONDITIONS = "BONUS_CONDITIONS",
    CONTINUE_TOP_UP = "CONTINUE_TOP_UP",
    UNLOCK_NEXT_BONUS = "UNLOCK_NEXT_BONUS",
    WELCOME_BONUS = "WELCOME_BONUS",
    WELCOME_BONUS_PROMO = "WELCOME_BONUS_PROMO",
    FREE_SPINS_GAME = "FREE_SPINS_GAME",
    CONFIRM = "CONFIRM",
    CONTACT_VERIFY = "CONTACT_VERIFY",
    SEARCH = "SEARCH",
    FUNDS_CREDITED = "FUNDS_CREDITED",
    WAGER_REQUIREMENT = "WAGER_REQUIREMENT",
    WALLET = 'WALLET',
    TX_CANCELLED = "TX_CANCELLED",
    PWA_INSTALL = "PWA_INSTALL",
    PUSH_PERMISSION = "PUSH_PERMISSION",
    PROMO_CODE_RESULT = "PROMO_CODE_RESULT",
    DELETE_ACCOUNT = "DELETE_ACCOUNT",
}
